<template>
  <div>
    <c-row>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-header>
            Card title
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/card-components"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            {{ loremIpsum }}
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-body>{{ loremIpsum }}</c-card-body>
          <c-card-footer>Card Footer</c-card-footer>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-header>
            <c-icon name="cil-check" />
            Card with icon
          </c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-header>
            Card with switch
            <c-switch
              class="float-right"
              size="sm"
              shape="pill"
              color="info"
              data-on="On"
              data-off="Off"
              :checked="true"
            />
          </c-card-header>
          <c-card-body>
            {{ loremIpsum }}
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-header>
            Card with label
            <c-badge color="success" class="float-right">Success</c-badge>
          </c-card-header>
          <c-card-body>
            {{ loremIpsum }}
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card>
          <c-card-header>
            Card with label
            <c-badge shape="pill" color="danger" class="float-right">42</c-badge>
          </c-card-header>
          <c-card-body>
            {{ loremIpsum }}
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="6" md="4">
        <c-card border-color="primary">
          <c-card-header>Card outline primary</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card border-color="secondary">
          <c-card-header>Card outline secondary</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card border-color="success">
          <c-card-header>Card outline success</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card border-color="info">
          <c-card-header>Card outline info</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card border-color="warning">
          <c-card-header>Card outline warning</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card border-color="danger">
          <c-card-header>Card outline danger</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
    </c-row>

    <c-row>
      <c-col sm="6" md="4">
        <c-card accent-color="primary">
          <c-card-header>Card with primary accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card accent-color="secondary">
          <c-card-header>Card with secondary accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card accent-color="success">
          <c-card-header>Card with success accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card accent-color="info">
          <c-card-header>Card with info accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card accent-color="info">
          <c-card-header>Card with info accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card accent-color="danger">
          <c-card-header>Card with danger accent</c-card-header>
          <c-card-body>{{ loremIpsum }}</c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="6" md="4">
        <c-card color="gradient-primary" class="text-center" body-wrapper text-color="white">
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-success" class="text-center" body-wrapper text-color="white">
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-info" class="text-center" body-wrapper text-color="white">
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-warning" class="text-center" body-wrapper text-color="white">
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-danger" class="text-center" body-wrapper text-color="white">
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-secondary" class="text-center" body-wrapper>
          <blockquote class="card-blockquote">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer>
              Someone famous in
              <cite title="Source Title">Source Title</cite>
            </footer>
          </blockquote>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="6" md="4">
        <c-card color="gradient-primary" body-wrapper text-color="white">
          {{ loremIpsum }}
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-success" body-wrapper text-color="white">
          {{ loremIpsum }}
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-info" body-wrapper text-color="white">
          {{ loremIpsum }}
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-warning" body-wrapper text-color="white">
          {{ loremIpsum }}
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <c-card color="gradient-danger" body-wrapper text-color="white">
          {{ loremIpsum }}
        </c-card>
      </c-col>
      <c-col sm="6" md="4">
        <transition name="fade">
          <c-card v-if="show" color="gradient-secondary">
            <c-card-header>
              Card with header actions
              <div class="card-header-actions">
                <c-link href="#" class="card-header-action btn-setting">
                  <c-icon name="cil-settings" />
                </c-link>
                <c-link class="card-header-action btn-minimize" @click="isCollapsed = !isCollapsed">
                  <c-icon :name="`cil-chevron-${isCollapsed ? 'bottom' : 'top'}`" />
                </c-link>
                <c-link href="#" class="card-header-action btn-close" @click="show = false">
                  <c-icon name="cil-x-circle" />
                </c-link>
              </div>
            </c-card-header>
            <c-collapse :show="isCollapsed" :duration="400">
              <c-card-body>
                {{ loremIpsum }}
              </c-card-body>
            </c-collapse>
          </c-card>
        </transition>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Cards',
  data() {
    return {
      show: true,
      isCollapsed: true,
      loremIpsum:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.',
    };
  },
};
</script>
